import { useSearchParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { RulesTab } from './RulesTab'
import { RolloutsTab } from './RolloutsTab'
import { HistoryTab } from './HistoryTab'
import { AngeboteTab } from './AngeboteTab'
import { BetriebBanner } from './BetriebBanner'

const TABS = ['regeln', 'rollouts', 'historie', 'angebote'] as const

export default function RolloutPage() {
  // ?tab=historie&sku=… kommt aus dem Grundartikel („Historie dieses Artikels“).
  // Der Reiter folgt der Adresse (auch bei späterer Navigation) und schreibt sie beim Wechsel.
  const [params, setParams] = useSearchParams()
  const roh = params.get('tab')
  const tab = roh && (TABS as readonly string[]).includes(roh) ? roh : 'regeln'
  const setTab = (next: string) => {
    const p = new URLSearchParams(params)
    if (next === 'regeln') p.delete('tab')
    else p.set('tab', next)
    if (next !== 'angebote') p.delete('angebot')
    setParams(p, { replace: true })
  }
  return (
    <div className="p-6 space-y-4">
      <header>
        <h1 className="font-display font-bold text-2xl text-ink">Preis-Rollout</h1>
        <p className="text-sm text-ink-2 mt-1">
          Regeln, nach denen Preise schrittweise auf das Ziel gebracht werden – und was dabei geschrieben wurde.
        </p>
      </header>
      <BetriebBanner />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="regeln">Regeln</TabsTrigger>
          <TabsTrigger value="rollouts">Rollouts</TabsTrigger>
          <TabsTrigger value="historie">Historie</TabsTrigger>
          <TabsTrigger value="angebote">Angebote</TabsTrigger>
        </TabsList>
        <TabsContent value="regeln"><RulesTab /></TabsContent>
        <TabsContent value="rollouts"><RolloutsTab /></TabsContent>
        <TabsContent value="historie"><HistoryTab /></TabsContent>
        <TabsContent value="angebote"><AngeboteTab /></TabsContent>
      </Tabs>
    </div>
  )
}
